import { SUPERSETS } from './supersets';
import { WARMUP_EXERCISES } from './warmupExercises';
import { LADDER_DRILL_OPTIONS } from './ladderDrills';
import { LEVEL_OPTIONS } from './levelOptions';

// Get supersets for a specific phase and workout
export function getSupersets(phaseNum, workoutNum) {
  const phaseKey = `phase_${phaseNum}`;
  const workoutKey = `workout_${workoutNum}`;
  return SUPERSETS[phaseKey]?.[workoutKey] || [];
}

// Get warmup data for a phase
export function getWarmupData(phaseNum) {
  return WARMUP_EXERCISES[`phase_${phaseNum}`] || null;
}

// Get ladder drill options for a phase
export function getLadderDrills(phaseNum) {
  return LADDER_DRILL_OPTIONS[`phase_${phaseNum}`] || [];
}

// Get level options based on level number
export function getLevels(levelNumber) {
  return LEVEL_OPTIONS[levelNumber] || [];
}

// Parse default values from documentation string
export function parseDefaultValues(documentation) {
  const defaults = {
    reps: null,
    holdTime: null,
  };

  if (!documentation) return defaults;

  // Parse reps (e.g., "3 x 6-8 reps" -> 6, "10/side" -> 10)
  const repsMatch = documentation.match(/(\d+)(?:-\d+)?\s*(?:reps|\/side)/i);
  if (repsMatch) {
    defaults.reps = parseInt(repsMatch[1], 10);
  }

  // Parse hold time (e.g., "20-30 seconds" -> 20)
  const holdMatch = documentation.match(/(\d+)(?:-\d+)?\s*seconds/i);
  if (holdMatch) {
    defaults.holdTime = parseInt(holdMatch[1], 10);
  }

  return defaults;
}

// Convert YouTube short URL to embed URL
export function getEmbedUrl(url) {
  if (!url) return null;
  
  // Handle youtu.be format
  if (url.includes('youtu.be/')) {
    const videoId = url.split('youtu.be/')[1]?.split('?')[0];
    return `https://www.youtube.com/embed/${videoId}`;
  }
  
  // Handle youtube.com/watch format
  if (url.includes('youtube.com/watch')) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const videoId = urlParams.get('v');
    return `https://www.youtube.com/embed/${videoId}`;
  }
  
  // Already embed format
  if (url.includes('youtube.com/embed/')) {
    return url;
  }
  
  return url;
}

// Get total exercise count for warmup
export function getWarmupExerciseCount(phaseNum) {
  const warmup = WARMUP_EXERCISES[`phase_${phaseNum}`];
  if (!warmup) return 0;
  return warmup.categories.reduce((total, cat) => total + cat.exercises.length, 0);
}

// Get superset count for a workout
export function getSupersetCount(phaseNum, workoutNum) {
  return getSupersets(phaseNum, workoutNum).length;
}